const profile = {
    name: '名稱',
    avatar: '頭像',
    givenName: '名字',
    familyName: '姓氏',
    middleName: '中間名',
    fullname: '全名',
    nickname: '暱稱',
    preferredUsername: '偏好用戶名',
    profile: '個人資料',
    website: '網站',
    gender: '性別',
    birthdate: '出生日期',
    zoneinfo: '時區',
    locale: '語言地區',
    address: {
        formatted: '地址',
        streetAddress: '街道地址',
        locality: '城市',
        region: '州／省份',
        postalCode: '郵遞區號',
        country: '國家',
    },
    gender_options: {
        female: '女性',
        male: '男性',
        prefer_not_to_say: '不願透露',
    },
    checkbox_value: {
        checked: '是',
        unchecked: '否',
    },
    avatar_upload: {
        upload: '上傳',
        remove: '移除',
        uploading: '上傳中...',
        hint: '建議尺寸 1:1，最大 {{limit}}。',
        error_file_type: '檔案類型必須為 {{extensions}}。',
        error_file_size: '檔案大小不能超過 {{limit}}。',
        error_storage_not_configured: '無法上傳照片，請稍後重試。',
        error_upload: '照片上傳失敗，請重試。',
        error_save: '照片儲存失敗，請重試。',
        crop_title: '裁剪相片',
        zoom: '縮放',
        error_crop: '圖片裁剪失敗，請重試。',
    },
};
export default Object.freeze(profile);
